import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { ProfileService } from '@teem/app/core/services/profile.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
@Component({
  selector: 'app-account-settings-modal',
  templateUrl: './account-settings-modal.component.html',
  styleUrls: ['./account-settings-modal.component.scss']
})
export class AccountSettingsModalComponent {
  @Input() isOpen: boolean = false;
  @Input() activeTab: string = 'general';
  @Output() close = new EventEmitter<void>();

  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  customerInfo: any;
  generalForm: FormGroup;
  passwordForm: FormGroup;

  constructor(
    private sharedDataService: SharedDataService,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private profileService: ProfileService,
    private customerAuthService: CustomerAuthService
  ) {

    this.generalForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      first_name: ['', [Validators.required, Validators.minLength(3)]],
			last_name: ['', [Validators.required, Validators.minLength(3)]],
			dob: ['', [Validators.required]],
			phone: ['', [Validators.required]],
    });

    this.passwordForm = this.fb.group({
      current_password: [null, []],
      new_password: ['', [Validators.required, Validators.minLength(6)]],
			confirm_password: ['', [Validators.required]],
    }, { validators: this.passwordMatchValidator });


  }

  ngOnInit(): void {
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.customerInfo) {
        this.customerInfo = data.customerInfo
        this.generalForm.patchValue({
          email: this.customerInfo.email,
          phone: this.customerInfo.phone,
          dob: this.customerInfo.dob,
          first_name: this.customerInfo.first_name,
          last_name: this.customerInfo.last_name,
        });
      }
    });
  }

  wire = {
    selected: false,
    uuid: 'unique-wire-id'
  };

  stcpay = {
    selected: false,
    uuid: 'unique-stcpay-id'
  };

  cards = {
    selected: false,
    uuid: 'unique-card-id'
  };

  closeModal(): void {
    this.close.emit();
    this.passwordForm.reset();
  }

  passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.get('new_password')?.value;
    const confirmPassword = control.get('confirm_password')?.value;
    if (password && confirmPassword && password !== confirmPassword) {
      control.get('confirm_password')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }
    return null;
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  togglePasswordVisibility(field: string): void {
    if (field === 'current') {
      this.showCurrentPassword = !this.showCurrentPassword;
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  onCheckboxChange(event: Event, uuid: string): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (uuid === this.wire.uuid) {
      this.wire.selected = isChecked;
    } else if (uuid === this.stcpay.uuid) {
      this.stcpay.selected = isChecked;
    } else if (uuid === this.cards.uuid) {
      this.cards.selected = isChecked;
    }

    console.log(`Checkbox for ${uuid} is now ${isChecked}`);
  }

  submit(){
    if(this.activeTab == 'general'){
      if(this.generalForm.valid){
        const loginData = {
          'email': this.generalForm.get('email').value, 
          'phone' : this.generalForm.get('phone').value,
          'first_name' : this.generalForm.get('first_name').value,
          'last_name' : this.generalForm.get('last_name').value,
          'dob' : this.generalForm.get('dob').value
        }
        this.loaderService.startLoading();
        this.profileService.updateInfo(loginData).subscribe({
          next: (res) => {
            this.loaderService.stopLoading();
            this.sharedDataService.setItem('customerInfo', res);
          },
          error: (err) => {
            this.loaderService.stopLoading();
            const errors = err.error?.errors;
            console.log(errors);
            if (errors?.email) {
              this.generalForm.get('email')?.setErrors({ serverError: errors.email[0] });
            }
  
            if (errors?.phone) {
              this.generalForm.get('phone')?.setErrors({ serverError: errors.phone[0] });
            }
          },
        });
      }else{
        this.generalForm.markAllAsTouched();
      }
    }else if(this.activeTab == 'reset-password'){
      if(this.passwordForm.valid){
        const passwordData = {
          'current_password': this.passwordForm.get('current_password').value, 
          'new_password' : this.passwordForm.get('new_password').value,
          'confirm_password' : this.passwordForm.get('confirm_password').value,
        }
        this.loaderService.startLoading();
        this.profileService.updatePassword(passwordData).subscribe({
          next: (res) => {
            this.loaderService.stopLoading();
            this.passwordForm.reset();
          },
          error: (err) => {
            this.loaderService.stopLoading();
            const errors = err.error?.errors;
            console.log(errors);
            if (errors?.current_password) {
              this.passwordForm.get('current_password')?.setErrors({ serverError: errors.current_password[0] });
            }
  
            if (errors?.new_password) {
              this.passwordForm.get('new_password')?.setErrors({ serverError: errors.new_password[0] });
            }

            if (errors?.confirm_password) {
              this.passwordForm.get('confirm_password')?.setErrors({ serverError: errors.confirm_password[0] });
            }
          },
        });
      }else{
        this.passwordForm.markAllAsTouched();
      }
    }
  }

  logout(){
    this.profileService.logout([]).subscribe({
      next: (res) => {
        this.loaderService.stopLoading();
        this.customerAuthService.logout();
        this.sharedDataService.setItem('customerInfo', []);
        // window.location.reload();
      },
      error: (err) => {
        this.loaderService.stopLoading();
        const errors = err.error?.errors;
      },
    });
  }
}
